export default __webpack_public_path__ + "static/media/separateur-adherents.c16b09e9.jpeg";